const MapsDebug = function(value, what, where, lineNr) {
    let enable = false;

    if (enable) {

        if (what === undefined) {
            what = '';
        }

        if (where === undefined) {
            where = '';
        }

        if (lineNr === undefined) {
            lineNr = '';
        } else {
            lineNr = ' [' + lineNr + ']';
        }

        var whereWhatString = (where !== undefined && where !== "") ? where + lineNr + ' > ' + what : what;

        if (typeof value === 'object') {

            console.group('%c TTGMaps Debug ', "background: #e014cb; color: #fff", whereWhatString);
            console.log(value);
            console.groupEnd();

        } else {

            console.log("%c TTGMaps Debug ", "background: #e014cb; color: #fff", whereWhatString + '\n' + value);

        }
    }

};